if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // The product page's quantity box sits outside the form (form="..."),
      // so querySelector misses it; form.elements includes it.
      let qtyInput = this.form.elements.namedItem('quantity');
      if (qtyInput && !(qtyInput instanceof HTMLInputElement)) qtyInput = qtyInput[0];
      if (qtyInput) {
        const val = parseInt(qtyInput.value) || 0;
        const min = parseInt(qtyInput.min) || 1;
        const max = qtyInput.max ? parseInt(qtyInput.max) : (qtyInput.dataset.max ? parseInt(qtyInput.dataset.max) : Infinity);
        const step = parseInt(qtyInput.step) || 1;
        if (val < min) {
          this.handleErrorMessage(`Minimum order quantity is ${min}.`);
          return;
        }
        if (val > max) {
          this.handleErrorMessage(`Maximum order quantity is ${max}.`);
          return;
        }
        if (step > 1 && val % step !== 0) {
          this.handleErrorMessage(`Quantity must be in increments of ${step}.`);
          return;
        }
        // The limit is per order: count what is already in the cart, or
        // repeated adds merge past it (#28901: 775 lb on a 250 lb limit).
        // Checkout refuses such a cart anyway, so a failed read lets it through.
        if (Number.isFinite(max)) {
          // Block a second click while the cart is read.
          this.submitButton.setAttribute('aria-disabled', true);
          const variantId = String((this.form.querySelector('[name=id]') || {}).value || '');
          try {
            const cart = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
            const inCart = (cart.items || []).filter((i) => String(i.variant_id) === variantId).reduce((a, i) => a + i.quantity, 0);
            if (inCart + val > max) {
              const msg = inCart > 0
                ? `You already have ${inCart} in your cart. The limit is ${max} per order. For more, contact orders@lagunaclay.com.`
                : `Maximum order quantity is ${max}.`;
              // Collection-page quick add has no error area.
              if (this.querySelector('.product-form__error-message-wrapper')) this.handleErrorMessage(msg);
              else window.alert(msg);
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }
          } catch (e) {}
        }
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

